import { Accordion } from '@design-system/accordion';
import { ImagePlusText } from '@design-system/image-plus-text';
import { PageBlock } from '@design-system/page-block';
import classnames from 'classnames';
import React, { forwardRef } from 'react';

import { imagePlusTextBlockMapper } from '~/mappers/imagePlusTextBlock';

import { AccordionListProps } from './models';

const AccordionList = forwardRef<HTMLDivElement, AccordionListProps>(
  (
    {
      list,
      headlineTag,
      semanticVariant,
      pageBlock,
      viewVariant,
      variant,
      componentId,
      expandedIndex,
    },
    ref
  ) => {
    const items = list.map(({ accordionTitle, content, disabled }) => ({
      title: accordionTitle,
      children: (
        <>
          {content.map((value) => (
            <ImagePlusText
              key={value.content}
              {...imagePlusTextBlockMapper({
                ...value,
                image: value.image?.[0],
              })}
            />
          ))}
        </>
      ),
      disabled,
      tabIndex: 0,
    }));

    return (
      <PageBlock
        {...pageBlock}
        id={componentId}
        className="accordion"
        ref={ref}
      >
        <Accordion
          items={items}
          headlineTag={headlineTag}
          semanticVariant={semanticVariant}
          expandVariant={variant}
          viewVariant={viewVariant}
          expandedIndex={
            expandedIndex ?? (componentId === 'faq-list' ? [0] : undefined)
          }
          className={classnames('accordion-list')}
          closeIcon={
            componentId === 'faq-list' ? { icon: 'arrowUp' } : { icon: 'hide' }
          }
          openIcon={
            componentId === 'faq-list' ? { icon: 'arrowDown' } : { icon: 'add' }
          }
        />
      </PageBlock>
    );
  }
);

export default AccordionList;
